'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div style={{ padding: '20px', fontFamily: 'system-ui' }}>
          <h1 style={{ color: '#dc2626' }}>Critical Application Error</h1>
          <p>The application encountered a critical error and cannot continue.</p>
          <pre style={{
            background: '#fee2e2',
            padding: '10px',
            borderRadius: '4px',
            overflow: 'auto'
          }}>
            {error.message || 'Unknown error'}
            {error.stack && `\n\n${error.stack}`}
          </pre>
          {error.digest && <p>Error ID: {error.digest}</p>}
          <button
            onClick={reset}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      </body>
    </html>
  )
}



